module.exports = __webpack_public_path__ + "img/icon_passive.d9ce36bc.svg";